// src/pages/TermsPage.js

import React from 'react';
import { Link } from 'react-router-dom';
import PublicNavbar from '../components/PublicNavbar';
import Footer from '../components/Footer'; 
import './TermsPage.css';

const TermsPage = () => {
  return (
    <div className="terms-page">
      <PublicNavbar />
      
      {/* Hero Section */}
      <header className="terms-hero">
        <div className="terms-hero-content">
          <h1>Terms of Use</h1>
          <p>Our Commitments and Your Responsibilities</p>
        </div>
      </header>

      {/* Main page content */}
      <div className="terms-main-content">
        <main>
          <section className="terms-section">
            <p>Last Updated: August of 2026</p>
            <p>
              Welcome to the Refuge AI mobile application and website (the "Service"). This Service is operated by Refuge AI, a 501(c)(3) non-profit organization, utilizing software infrastructure licensed by Beneficial AI, LLC. 
            </p>
            <p>
              By downloading, accessing, or using the Service, you agree to be bound by these Terms of Use. If you do not agree to these terms, do not use the Service.
            </p>
          </section>

          <section className="terms-section">
            <h2>1. Use of the Service</h2>
            <p>
              The Service provides curated resources, community features, and map-based navigation. You agree to use the Service only for lawful purposes and in accordance with these Terms. You are responsible for maintaining the confidentiality of your account login information.
            </p>
          </section>

          <section className="terms-section">
            <h2>2. Intellectual Property</h2>
            <p>
              The content, curated resources, and community data provided through the Service are managed by Refuge AI. 
            </p>
            <p>
              The underlying software, source code, app design, and technical architecture are the exclusive intellectual property of Beneficial AI, LLC. You are granted a limited, non-exclusive, non-transferable license to use the app strictly for its intended personal, non-commercial purposes. You may not copy, modify, distribute, or reverse-engineer any part of the software.
            </p>
          </section>

          <section className="terms-section">
            <h2>3. Third-Party Integrations</h2>
            <p>
              The Service integrates with third-party applications on your device, such as Google Maps, email clients, and SMS messaging. Refuge AI and Beneficial AI, LLC do not control these third-party services and are not responsible for their accuracy, availability, or data practices.
            </p>
          </section>

          <section className="terms-section">
            <h2>4. Disclaimer of Warranties</h2>
            <p>
              THE SERVICE IS PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS. TO THE MAXIMUM EXTENT PERMITTED BY LAW, REFUGE AI AND BENEFICIAL AI, LLC EXPRESSLY DISCLAIM ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
            </p>
            <p>
              Neither Refuge AI nor Beneficial AI, LLC guarantees that the Service will be uninterrupted, error-free, secure, or that the map routing and location data will always be perfectly accurate. 
            </p>
          </section>

          <section className="terms-section">
            <h2>5. Limitation of Liability</h2>
            <p>
              UNDER NO CIRCUMSTANCES SHALL BENEFICIAL AI, LLC, REFUGE AI, OR THEIR RESPECTIVE OFFICERS, DIRECTORS, VOLUNTEERS, OR PROGRAMMERS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, CONSEQUENTIAL, SPECIAL, OR EXEMPLARY DAMAGES ARISING OUT OF OR IN CONNECTION WITH YOUR USE OF THE SERVICE.
            </p>
            <p>
              This includes, but is not limited to, damages for loss of profits, data breaches, personal injury, property damage, or any issues arising from the use of navigation features. Your sole remedy for dissatisfaction with the Service is to stop using it.
            </p>
          </section>

          <section className="terms-section">
            <h2>6. Termination</h2>
            <p>
              We reserve the right to suspend or terminate your account and access to the Service at our sole discretion, without notice or liability, for any reason, including a breach of these Terms.
            </p>
          </section>

          <section className="terms-section">
            <h2>7. Governing Law</h2>
            <p>
              These Terms shall be governed by and construed in accordance with the laws of the State of Arizona, without regard to its conflict of law provisions.
            </p>
          </section>

          <section className="terms-section">
            <h2>8. Changes to These Terms</h2>
            <p>
              We may update these Terms from time to time. Continued use of the Service after any modifications indicates your acceptance of the updated Terms.
            </p>
          </section>

          <section className="terms-section">
            <h2>9. Contact Us</h2>
            <p>
              For questions regarding these Terms, please contact us by visiting our <Link to="/contact">Contact page</Link>.
            </p>
          </section>
        </main>
      </div>

      <Footer />
    </div>
  );
};

export default TermsPage;